import { PUT, POST } from '@/api/api'
import { DestinationFormData } from '@/types/destinationFormData'
import { formatPostalCode } from '@/utils/inputFormatter'

export const useSaveDestination = () => {
  const save = async (
    formData: DestinationFormData,
    startDate: string,
    id?: string,
  ) => {
    const applicableDate = new Date(startDate.toString())
    const today = new Date()
    applicableDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)
    const isPastOrToday = applicableDate <= today

    const isNewEntry = !id
    const shouldUsePost = isNewEntry || isPastOrToday
    const url =
      isNewEntry || isPastOrToday
        ? '/api/destinations'
        : `/api/destinations/${id}`
    const method = shouldUsePost ? POST : PUT

    const postalCode = formatPostalCode(
      formData.postalCode1,
      formData.postalCode2,
    )
    return method(url, {
      ...formData,
      postalCode,
    })
  }

  return { save }
}
